import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { SubscribableTitleService } from './subscribable-title.service';
import { BgColors } from '../models/bg_color.model';

@Injectable()
export class CustomizeColorService {
  url = '';

  constructor(
    private http: HttpClient,
    private storeBG: Store<BgColors>,
    private subscriableTitleService: SubscribableTitleService,
    @Inject('BASE_URL') baseUrl: string
  ) {
    this.url = baseUrl;
  }

  async GetBackground() {
    return this.http.get<BgColors[]>(this.url + 'api/CustomizeColor/getdata_color')
      .toPromise()
      .then(result => {
        this.storeBG.dispatch({ type: 'INIT_BG', bg: result });
        this.subscriableTitleService.setMetaThemeColor(result[0][0]);
        return result[0][0];
      })
      .catch(err => console.log(err));
  }
}



// WEBPACK FOOTER //
// ./src/app/services/customizeColor.service.ts